import { FormValidationDefinition } from "../../../../../../common/components/form/use-form";
import phoneNumberInputHelper from "../../../../../../common/components/form/input/phone-number/phone-number-input.helper";
import dispatcherAddByCargoFormValidationService from "./dispatcher-add-by-cargo-form-validation.service";
import DispatcherAddFormData from "../../common/types/dispatcher-add-form-data";

const getDefaultFormData = (): DispatcherAddFormData => {
  return {
    firstName: "",
    lastName: "",
    phoneNumber: phoneNumberInputHelper.getEmptyValue(),
    alternativePhoneNumber: phoneNumberInputHelper.getEmptyValue(),
    email: "",
    username: "",
    password: "",
    passwordRepeat: "",
    dispatchUuid: "",
  };
};
const getValidationDefinition =
  (): FormValidationDefinition<DispatcherAddFormData> => {
    return {
      alternativePhoneNumber: (values) =>
        dispatcherAddByCargoFormValidationService.validateAlternativePhoneNumber(
          values.alternativePhoneNumber
        ),
      dispatchUuid: (values) =>
        dispatcherAddByCargoFormValidationService.validateDispatch(
          values.dispatchUuid
        ),
      email: (values) =>
        dispatcherAddByCargoFormValidationService.validateEmail(values.email),
      firstName: (values) =>
        dispatcherAddByCargoFormValidationService.validateFirstName(
          values.firstName
        ),
      lastName: (values) =>
        dispatcherAddByCargoFormValidationService.validateLastName(
          values.lastName
        ),
      password: (values) =>
        dispatcherAddByCargoFormValidationService.validatePassword(
          values.password
        ),
      passwordRepeat: (values) =>
        dispatcherAddByCargoFormValidationService.validatePasswordRepeat(
          values.password,
          values.passwordRepeat
        ),
      phoneNumber: (values) =>
        dispatcherAddByCargoFormValidationService.validatePhoneNumber(
          values.phoneNumber
        ),
      username: async (values) =>
        await dispatcherAddByCargoFormValidationService.validateUsername(
          values.username
        ),
    };
  };

const dispatcherAddByCargoAddFormHelper = {
  getDefaultFormData,
  getValidationDefinition,
};

export default dispatcherAddByCargoAddFormHelper;
